import { CouponBase } from "../coupon-base";
import { AllMatchGroupItemTriggerItemsQualifier } from "../../coupon-qualifiers/trigger-items/all-match-group-item-trigger-items";
import { MinimumQuantityQualifier } from "../../coupon-qualifiers/minimum-quantity";
export class MixAndMatchBaseCoupon extends CouponBase {
    discountValue;
    minimumItemQuantity;
    constructor(appType, sourceData, dependencies, baseData, identity, minimumItemQuantity = null) {
        super(appType, sourceData, dependencies, baseData, identity);
        this.discountValue = baseData.discount;
        this.minimumItemQuantity = minimumItemQuantity;
        this._preQualifiers.push(this.createTriggerItemsQualifier());
    }
    /**
     * Trigger-item search strategy for this coupon.
     *
     * Mix-and-match sweeps up every matching cart item (legacy re-qualifies the same
     * coupon item until nothing is left), so the default is the all-match qualifier.
     * QUANTITY_PRICE and QUANTITY_DISCOUNT override this with the single-pass first-match search.
     *
     * NOTE: this is invoked from the constructor, so overrides may only read state set
     * by CouponBase (e.g. `this._data`) — subclass field initializers have not run yet.
     */
    createTriggerItemsQualifier() {
        return new AllMatchGroupItemTriggerItemsQualifier(this._data);
    }
    /**
     * Whether this coupon gates qualification on the configured minimum item quantity.
     * Default true preserves existing mix-and-match behavior; QUANTITY_PRICE and
     * QUANTITY_DISCOUNT override to false because legacy never applies the min-qty
     * check to those types.
     */
    get enforcesMinimumQuantity() {
        return true;
    }
    meetsPreConditions(cart) {
        const result = super.meetsPreConditions(cart);
        if (!result.isValid)
            return result;
        if (!this.enforcesMinimumQuantity)
            return result;
        return new MinimumQuantityQualifier(this.getTriggerItems.length).qualify(this._coupon, cart);
    }
    getDiscountItems(cart) {
        return this._getDiscountItemsFromTriggers(cart);
    }
    calculateDiscount(cart) {
        const discountItems = this.getDiscountItems(cart);
        const totals = this._getTotalCouponItemsPrices(discountItems);
        let discountAmount = this.computeDiscountAmount(discountItems);
        discountAmount = Math.max(0, this._adjustDiscountAmount(cart, discountAmount));
        if (this._coupon.isBeforeTax) {
            this.getBeforeTaxDistributor().distribute({
                cart,
                discountItems,
                totalDiscountedItemsPrice: totals.orderItemPrice,
                computedDiscountToAllocate: discountAmount,
                configuredDiscountValue: this.getConfiguredDiscountValueForDistribution()
            });
        }
        else {
            this.getAfterTaxDistributor().distribute({
                cart,
                discountItems,
                totalDiscountedItemsPrice: totals.orderItemPrice,
                computedDiscountToAllocate: discountAmount
            });
        }
        return [discountAmount, discountItems];
    }
    /**
     * Only meaningfully used by quantity/mix&match-price logic inside CouponBase.
     * Override for percent coupons if you want to avoid passing a misleading value.
     */
    getConfiguredDiscountValueForDistribution() {
        return this.discountValue;
    }
}
//# sourceMappingURL=mix-and-match-base.js.map